import { render } from "./IdDataGrid.vue?vue&type=template&id=09bc6209"
import script from "./IdDataGrid.vue?vue&type=script&lang=js"
export * from "./IdDataGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__